class Hidden extends Events
{
  constructor ()
  {
    super();
  }

  async show (productId, cb)
  {
    try {
      const response = await fetch('https://app.donornetwork.com/api/shopify/customer/curation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...app.apiHeaders()
        },
        body: JSON.stringify({
          product_id: 'gid://shopify/Product/' + productId,
          action: 'remove',
          type: 'hide'
        })
      });

      const data = await response.json();

      if (data.data) {
        // Update cache with full curations response
        app.cache.put(window.cacheKeys.customerCurations, data.data, 86400);

        // Update customer curations data in memory
        if (app.customer.curationsData) {
          app.customer.curationsData = data.data;
        }

        // Broadcast events to update UI
        broadcast('hiddenProducts');

        if (typeof(cb) === 'function') {
          cb(null);
        }
      } else {
        console.error('Failed to show product:', data);
        if (typeof(cb) === 'function') {
          cb(data);
        }
      }
    } catch (error) {
      console.error('Error showing product:', error);
      if (typeof(cb) === 'function') {
        cb(error);
      }
    }
  }

  async hide (productId, cb)
  {
    try {
      const response = await fetch('https://app.donornetwork.com/api/shopify/customer/curation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...app.apiHeaders()
        },
        body: JSON.stringify({
          product_id: 'gid://shopify/Product/' + productId,
          action: 'add',
          type: 'hide'
        })
      });

      const data = await response.json();

      if (data.data) {
        // Update cache with full curations response
        app.cache.put(window.cacheKeys.customerCurations, data.data, 86400);

        // Update customer curations data in memory
        if (app.customer.curationsData) {
          app.customer.curationsData = data.data;
        }

        // Broadcast events to update UI
        broadcast('hiddenProducts');

        if (typeof(cb) === 'function') {
          cb(null);
        }
      } else {
        console.error('Failed to hide product:', data);
        if (typeof(cb) === 'function') {
          cb(data);
        }
      }
    } catch (error) {
      console.error('Error hiding product:', error);
      if (typeof(cb) === 'function') {
        cb(error);
      }
    }
  }

  isVisible (productId)
  {
    const curations = app.cache.get(window.cacheKeys.customerCurations);

    if (!curations) {
      return true;
    }

    let visible = true;
    const currentProductId = "gid://shopify/Product/" + productId;

    curations.forEach(product => {
      if (product.type !== 'hide') {
        return;
      }
      if (product.product_id == currentProductId) {
        visible = false;
      }
    });

    return visible;
  }
}